import { render, staticRenderFns } from "./batch.vue?vue&type=template&id=2b4d9d72&scoped=true"
import script from "./batch.vue?vue&type=script&lang=js"
export * from "./batch.vue?vue&type=script&lang=js"
import style0 from "./batch.vue?vue&type=style&index=0&id=2b4d9d72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4d9d72",
  null
  
)

export default component.exports